import { render, staticRenderFns } from "./PageNavigationLink.vue?vue&type=template&id=e1b00186&"
import script from "./PageNavigationLink.vue?vue&type=script&lang=js&"
export * from "./PageNavigationLink.vue?vue&type=script&lang=js&"
import style0 from "./PageNavigationLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports